import { replace } from 'redux-first-history';

import isExternalURI from '../uri/isExternalURI';

export default (url: string) => (dispatch: any) =>
  isExternalURI(url) ? window.location.replace(url) : dispatch(replace(url));
